import React, { memo } from "react";

import AuthSocialIframeForm from "../AuthSocialIframeForm";
import AuthSocialForm from "../AuthSocialForm";

import { Container, Divider, Text, Wrapper } from "./styles";

const AuthSocial = ({ title }) => (
  <Container>
    <Wrapper>
      <Divider />

      <Text>or</Text>

      <Divider />
    </Wrapper>

    {window.self !== window.top ? (
      <AuthSocialIframeForm title={title} />
    ) : (
      <AuthSocialForm title={title} />
    )}
  </Container>
);

export default memo(AuthSocial);
